export enum ColumnFilterType {
  Date = 'date',
  Number = 'number',
  Boolean = 'boolean',
  Text = 'text',
  Set = 'set',
  Custom = 'custom',
}
